<template lang="pug">
  .container-listagem
    el-row
      VincularProcesso(@closeModal="closeModalVincular",@incluir="incluir", :nomeDocumento="nomeDocumento", :tipoDocumento="tipoDocumento", v-if="modalVincular")
      el-col
        Pesquisa(
          placeHolder = "Informe o nome do documento, responsável ou tipo do documento"
          @search="handlePesquisa"
          @resetSearch="resetPesquisa"
          :cardStyle="{margin:'0px 0px 10px 0px', 'border-radius':'12px'}"
          :hasPesquisaAvancada="true"
          @searchAdvanced="pesquisarAvancado"
          @changeTipoPesquisa="changeTipoPesquisa"
        )
          template(slot="pesquisaAvancada")
            pesquisa-avancada-documentos-assinados(
              :filtro="pesquisaAvancada"
            )

    el-card.default-card(shadow="hover")
      app-divider-refresh-button(
        label="Listagem de Documentos",
        @click="resetPesquisa",
        :hasButton="true"
        content="Atualizar documentos"
      )

      el-table.table(:data="documentosAssinados" ref="table" @sort-change='sortChanged')
        template(slot="empty") Não há registros.
        el-table-column(
          prop='nome'
          label='Nome do documento',
          width="auto"
          sortable="custom"
          :formatter="Utils.formatEmptyRow"
        )

        el-table-column(
          prop="assinadores.responsavel.usuario.pessoa.pessoaFisica.nome"
          label='Responsável(eis)',
          :formatter="Utils.formatEmptyRow"
          width="auto"
          sortable="custom"
        )
          template(slot-scope='scope')
            list-responsavel-assinatura(:assinadores="scope.row.assinadores" :showIcon="false")

        el-table-column(
          prop="assinadores.dataAssinatura"
          label='Datas de assinatura',
          width="auto"
          sortable="custom"
          :formatter="formatDate"
        )
          template(slot-scope='scope')
            .item-list(v-for="assinador in scope.row.assinadores")
              span {{formatDataAssinatura(assinador.dataAssinatura)}}

        el-table-column(
          prop='tipo.nome'
          label='Documento',
          :formatter="Utils.formatEmptyRow"
          width="auto"
          sortable="custom"
        )
        el-table-column(
          prop='numeroProcesso'
          label='Processo vinculado',
          :formatter="Utils.formatEmptyRow"
          width="auto"
          sortable="custom"
        )
        el-table-column(
          label='Ações',
          width='120'
        )
          template(slot-scope='scope')
            button-acoes(:acoes="botoesAcao(scope.row)")

      app-paginacao(
        :total="totalCadastros"
        :pagina="pagina",
        @changePage="changePage"
      )

</template>

<script>
import { mapActions } from 'vuex'
import ButtonAcoes from '@/components/ButtonAcoes'
import AppPaginacao from '@/components/AppPaginacao'
import AppDividerRefreshButton from '@/components/AppDividerRefreshButton'
import Pesquisa from '@/components/Pesquisa'
import PesquisaAvancadaDocumentosAssinados from '@/screens/assinatura/components/PesquisaAvancadaDocumentosAssinados'
import Utils from '@/utils/utils'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import CONFIGS from '@/constants/configs'
import FileHelper from '@/utils/fileHelper'
import cloneDeep from 'lodash/cloneDeep'
import ListResponsavelAssinatura from '@/screens/assinatura/components/ListResponsavelAssinatura'
import VincularProcesso from '@/screens/assinatura/VincularProcesso'

const FILTRO_EMPTY = {
  pagina: 0,
  tamanhoPagina: CONFIGS.TAMANHO_PAGINACAO,
  assinado: true
}

const PESQUISA_AVANCADA_EMPTY = {
  nome: null,
  responsavel: null,
  dataAssinatura: null,
  tipoDocumento: null
}

export default {
  data () {
    return {
      documentosAssinados: [],
      totalCadastros: 0,
      documentoSelecionado: null,
      nomeDocumento: '',
      tipoDocumento: '',
      modalVincular: false,
      filtro: cloneDeep(FILTRO_EMPTY),
      pesquisaAvancada: cloneDeep(PESQUISA_AVANCADA_EMPTY),
      Utils,
      idDocumento: null,
      hasClickFinalizar: false,
      naoValido: true
    }
  },

  components: {
    ButtonAcoes,
    AppPaginacao,
    AppDividerRefreshButton,
    Pesquisa,
    ListResponsavelAssinatura,
    PesquisaAvancadaDocumentosAssinados,
    VincularProcesso
  },

  mixins: [
    AppNotificacao
  ],

  computed: {
    pagina () {
      return this.filtro.pagina + 1
    }
  },

  methods: {
    ...mapActions({
      findDocumentos: 'documentoAssinatura/find',
      setMainCardVisibility: 'userInterface/setMainCardVisibility',
      resetLoader: 'loader/resetLoader',
      downloadDocumentos: 'documentoAssinatura/download',
      setLoader: 'loader/setLoader',
      vinculaprocesso: 'documentoAssinatura/vincular',
      hasProcessoVinculado: 'documentosAssinatura/hasProcessoVinculado'
    }),

    closeModalVincular (documento) {
      if (documento) {
        this.idDocumento = documento.id
        this.documentoSelecionado = documento
        this.nomeDocumento = documento.nome
        this.tipoDocumento = documento.tipo.nome
      }
      this.modalVincular = !this.modalVincular
    },

    changeTipoPesquisa (value) {
      this.filtro.simplificado = value
    },

    resetPesquisa () {
      this.filtro.pesquisaSimples = ''
      this.pesquisaAvancada.nome = ''
      this.pesquisaAvancada.responsavel = null
      this.pesquisaAvancada.tipoDocumento = null
      this.pesquisaAvancada.dataAssinatura = null
      this.filtro.responsavel = null
      this.filtro.tipoDocumento = null
      this.filtro.dataAssinaturaInicio = null
      this.filtro.dataAssinaturaFim = null
      this.getDocumentosAssinados()
    },

    handlePesquisa (value) {
      this.filtro.pesquisaSimples = value
      this.getDocumentosAssinados()
    },

    changePage (newPage) {
      this.filtro.pagina = newPage - 1
      this.getDocumentosAssinados()
    },

    incluir (idProcesso) {
      const dado = {
        id: idProcesso,
        idDoc: this.idDocumento
      }
      this.$confirm(
        'Tem certeza que deseja incluir o número?',
        {
          confirmButtonText: 'Confirmar',
          cancelButtonText: 'Cancelar',
          type: 'warning'
        }
      )
        .then(() => {
          this.vinculaprocesso(dado)
          this.showNotificacao(
            this.$messages.TIPO_SUCCESS,
            this.$messages.TITULO_SUCCESS,
            'Número do processo incluído com sucesso'
          )
          this.closeModalVincular()
          this.resetPesquisa()
        })
        .catch(() => {

        })
    },

    botoesAcao (documento) {
      const botoes = [
        {
          click: this.visualizar.bind(this, documento),
          icon: 'visibility',
          title: 'Visualizar documento',
          active: true
        },
        {
          click: this.downloadDocumento.bind(this, documento),
          icon: 'get_app',
          title: 'Download do documento',
          active: true
        }
      ]
      const tiposPermitidos = ['Título REURB', 'Título Rural', 'Certidão de Autenticidade de Títulos']
      if (tiposPermitidos.includes(documento.tipo.nome) && documento.numeroProcesso === null) {
        botoes.push({
          click: this.closeModalVincular.bind(this, documento),
          icon: 'edit',
          title: 'Vincular Processo',
          active: true
        })
      }
      return botoes
    },

    async getDocumentosAssinados () {
      this.setLoader()
      await this.getDocumentosAssinadosSemLoader()
      this.resetLoader()
    },

    async getDocumentosAssinadosSemLoader () {
      this.setFiltroAdvancedSearch()
      const result = await this.findDocumentos(this.filtro)
      this.documentosAssinados = result.documentosAssinatura
      this.totalCadastros = result.total
    },

    formatDate (row, column, prop) {
      return Utils.formatDate(prop) || '-'
    },

    async downloadDocumento (documento) {
      const arrayBuffer = await this.downloadDocumentos({ id: documento.id })
      FileHelper.saveFile(arrayBuffer, `${documento.nome}.pdf`)
    },

    visualizar (documento) {
      this.$router.push({
        name: 'assinatura/visualizarDocumentoAssinado',
        query: {
          id: documento.id
        }
      })
    },

    sortChanged ({ column, prop, order }) {
      if (order !== null) {
        const direcaoMap = {
          'ascending': 'ASC',
          'descending': 'DESC'
        }
        this.filtro.ordem = prop
        this.filtro.ordemDirecao = direcaoMap[order]
      }

      this.getDocumentosAssinados()
    },

    formatDataAssinatura (data) {
      return Utils.formatDate(data)
    },
    async pesquisar (pesquisaSimples) {
      this.setFiltroAdvancedSearch(pesquisaSimples)
      await this.getDocumentosAssinados()
    },
    async pesquisarAvancado () {
      this.setFiltroAdvancedSearch()
      await this.pesquisar()
    },
    setFiltroAdvancedSearch (pesquisaSimples) {
      this.filtro.nome = pesquisaSimples || this.pesquisaAvancada.nome

      if (this.pesquisaAvancada.responsavel) {
        this.filtro.responsavel = this.pesquisaAvancada.responsavel.usuario.pessoa.nomeRazaoSocial
      }

      if (this.pesquisaAvancada.dataAssinatura) {
        this.filtro.dataAssinaturaInicio = this.pesquisaAvancada.dataAssinatura[0]
        this.filtro.dataAssinaturaFim = this.pesquisaAvancada.dataAssinatura[1]
      }

      if (this.pesquisaAvancada.tipoDocumento) {
        this.filtro.tipoDocumento = this.pesquisaAvancada.tipoDocumento
      }
    }

  },

  created () {
    this.setMainCardVisibility(false)
    this.getDocumentosAssinados()
  }
}

</script>

<style>
.item-list {
  padding:5px;
  padding: 5px 0px;
}

.list-responsavel {
  margin-left: -5px;
}
</style>



// WEBPACK FOOTER //
// src/screens/assinatura/ListagemDocumentosAssinados.vue